import React, { useContext } from 'react';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import ModalPortal from '../../../../../components/modal-portal';
import messages from '../messages';
import { DeliveryOptionsContext } from './context';
import PreviewModal from './preview-modal';
import ErrorBoundary from '../../../../../components/error-boundary';

export const PreviewDeliveryOptionsButton = () => {
  const { showPreviewModal, openPreviewModal, closePreviewModal, isRegistered, items } = useContext(DeliveryOptionsContext);

  return (
    <>
      <Button
        data-pendo-id='/settings/stores#preview-delivery-option'
        disabled={!isRegistered || !items.length}
        onClick={openPreviewModal}
        theme='secondary'
      >
        <FormattedMessage {...messages.previewDeliveryOptionButton} />
      </Button>
      {showPreviewModal && (
        <ModalPortal onClose={closePreviewModal}>
          <ErrorBoundary errorMessageId='checkoutRatesPreview'>
            <PreviewModal />
          </ErrorBoundary>
        </ModalPortal>
      )}
    </>
  );
};
